export default import.meta.ROLLDOWN_FILE_URL_gOnlbS3Cmxji$pdZZMY03g